// extracted by mini-css-extract-plugin
export default {"heading":"heading---JJjO","items":"items---JJjO","subheading":"subheading---JJjO","foot":"foot---JJjO"};